import { AxiosResponse } from "axios";
import HttpService from "src/services/httpService";
import RouteService from "src/services/routeService";

import { Build } from "@dashboard/products/types";
import AuthService from "@services/authService";

export type BuildConfig = {
    version: string;
    changes: string[];
    configSnapshot: {
        [key: string]: unknown;
    };
    rolloutPercentage: number;
    configOverride: {
        manifest?: {
            fromVersion?: string;
        };
        ota?: {
            incrementalFromVersions?: string[];
        };
        buildVariant?: "user" | "userdebug" | "eng";
        compatibility?: string;
    };
};

async function downloadBuild(productId: number, buildId: number, signal: AbortSignal): Promise<Response> {
    const endpoint = await RouteService.getProductRoute();

    // Must use fetch instead of axios because axios doesn't have access to headers when downloading files
    return fetch(`${endpoint}products/${productId}/builds/${buildId}/export`, {
        headers: { "Authorization": `Bearer ${AuthService.getSession()?.access_token}` },
        signal,
    });
}

// previously: requestDownloadBuildLog
async function downloadBuildLog(payload: Build["buildId"]): Promise<AxiosResponse<Blob>> {
    const endpoint = await RouteService.getProductRoute();
    return HttpService.get<string, AxiosResponse<Blob>>(endpoint + "logging/full", {
        responseType: "blob",
        params: { buildId: payload },
    });
}

// previously: requestStreamBuildLog
async function streamBuildLog(buildId: Build["buildId"], token: string): Promise<Response> {
    const endpoint = await RouteService.getProductRoute();

    // Must use fetch instead of axios because axios doesn't have access to headers when downloading files
    return fetch(`${endpoint}logging/stream?buildId=${buildId}`, {
        headers: {
            "Authorization": `Bearer ${token}`,
            "Accept": "text/plain",
            "Connection": "keep-alive",
            "Keep-Alive": "timeout=5, max=1000",
        },
    });
}

export default {
    downloadBuild,
    downloadBuildLog,
    streamBuildLog,
};
